<template>
  <div>
    <el-dialog
        :title="'Xóa dữ liệu trùng'"
        :visible.sync="showDeleteAttendanceDuplicateDialog"
        width="700px"
        :before-close="closeDialog"
        :close-on-click-modal="false"
        top="10vh"
    >
      <div>
        <el-row>
          <el-col :span="2">
            <el-date-picker
                style="width: 150px"
                size="medium"
                v-model="dataInput.date"
                type="date"
                value-format="yyyy-MM-dd"
                format="dd-MM-yyyy"
                placeholder="Chọn ngày"
                :clearable="false"
            ></el-date-picker>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
         <el-col :span="12">
           <el-button
               type="primary"
               size="mini"
               :loading="buttonLoading1"
               @click="checkAttendanceDuplicate()"
           >KTra điểm danh
           </el-button>
           &nbsp;&nbsp; KQ:{{ countAttendanceDuplicate }} &nbsp;
           <el-button
               type="danger"
               size="mini"
               :disabled="countAttendanceDuplicate === 0"
               :loading="buttonLoading2"
               @click="deleteAttendanceDuplicate()"
           >Xóa điểm danh
           </el-button>
         </el-col>
          <el-col :span="12">
            <el-button
                type="primary"
                size="mini"
                :loading="buttonLoading3"
                @click="checkEvaluateDuplicate()"
            >KTra nhận xét
            </el-button>
            &nbsp;&nbsp; KQ:{{ countEvaluateDuplicate }} &nbsp;
            <el-button
                type="danger"
                size="mini"
                :disabled="countEvaluateDuplicate === 0"
                :loading="buttonLoading4"
                @click="deleteEvaluateDuplicate()"
            >Xóa nhận xét
            </el-button>
         </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-col :span="12">
            <el-button
                type="primary"
                size="mini"
                :loading="buttonLoading5"
                @click="checkQrCodeDuplicate()"
            >KTra mã QR
            </el-button>
            &nbsp;&nbsp; KQ:{{ countQrCodeDuplicate }} &nbsp;
            <el-button
                type="danger"
                size="mini"
                :disabled="countQrCodeDuplicate  === 0"
                :loading="buttonLoading6"
                @click="deleteQrCodeDuplicate()"
            >Xóa mã QR
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import OtherService from "@/services/CommonService/OtherService";

export default {
  props: {
    showDeleteAttendanceDuplicateDialog: {
      type: Boolean,
      default: () => false
    },
  },
  data() {
    return {
      dataInput: {
        date: "",
      },
      buttonLoading1: false,
      buttonLoading2: false,
      buttonLoading3: false,
      buttonLoading4: false,
      buttonLoading5: false,
      buttonLoading6: false,
      countAttendanceDuplicate: 0,
      countEvaluateDuplicate: 0,
      countQrCodeDuplicate : 0,
    };
  },

  methods: {
    closeDialog() {
      this.dataInput.date = "";
      this.buttonLoading1 = false
      this.buttonLoading2 = false
      this.buttonLoading3 = false
      this.buttonLoading4 = false
      this.buttonLoading5 = false
      this.buttonLoading6 = false
      this.countAttendanceDuplicate = 0
      this.countEvaluateDuplicate = 0
      this.$emit('close', false);
    },
    checkDateDuplicate() {
      if (this.dataInput.date === "") {
        this.$message({
          message: "Chọn ngày xóa dữ liệu trùng",
          type: "error",
        });
        throw null;
      }
    },
    checkAttendanceDuplicate() {
      this.checkDateDuplicate();
      this.buttonLoading1 = true;
      OtherService.getAttendanceDuplicateService(this.dataInput.date)
          .then((resp) => {
            this.countAttendanceDuplicate = resp.data.data;
          })
          .catch((err) => {
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
          })
          .finally(() => {
            setTimeout(() => {
              this.buttonLoading1 = false;
            }, 500);
          });
    },
    deleteAttendanceDuplicate() {
      this.checkDateDuplicate();
      this.$confirm(
          "Bạn có chắc chắn muốn xóa điểm danh trùng không?",
          "Thông báo!",
          {
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            confirmButtonText: "Có",
            cancelButtonText: "Không",
          }
      ).then(() => {
        this.buttonLoading2 = true;
        OtherService.deleteAttendanceDuplicateService(this.dataInput.date)
            .then((resp) => {
              this.$message({
                message: resp.data.message,
                type: "success",
              });
              this.checkAttendanceDuplicate();
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            })
            .finally(() => {
              setTimeout(() => {
                this.buttonLoading2 = false;
              }, 500);
            });
      });
    },
    checkEvaluateDuplicate() {
      this.checkDateDuplicate();
      this.buttonLoading3 = true;
      OtherService.getEvaluateDuplicateService(this.dataInput.date)
          .then((resp) => {
            this.countEvaluateDuplicate = resp.data.data;
          })
          .catch((err) => {
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
          })
          .finally(() => {
            setTimeout(() => {
              this.buttonLoading3 = false;
            }, 500);
          });
    },
    deleteEvaluateDuplicate() {
      this.checkDateDuplicate();
      this.$confirm(
          "Bạn có chắc chắn muốn xóa nhận xét trùng không?",
          "Thông báo!",
          {
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            confirmButtonText: "Có",
            cancelButtonText: "Không",
          }
      ).then(() => {
        this.buttonLoading4 = true;
        OtherService.deleteEvaluateDuplicateService(this.dataInput.date)
            .then((resp) => {
              this.$message({
                message: resp.data.message,
                type: "success",
              });
              this.checkEvaluateDuplicate();
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            })
            .finally(() => {
              setTimeout(() => {
                this.buttonLoading4 = false;
              }, 500);
            });
      });
    },
    checkQrCodeDuplicate() {
      this.checkDateDuplicate();
      this.buttonLoading5 = true;
      OtherService.getQrCodeDuplicateService(this.dataInput.date)
          .then((resp) => {
            this.countQrCodeDuplicate = resp.data.data;
          })
          .catch((err) => {
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
          })
          .finally(() => {
            setTimeout(() => {
              this.buttonLoading5 = false;
            }, 500);
          });
    },
    deleteQrCodeDuplicate() {
      this.checkDateDuplicate();
      this.$confirm(
          "Bạn có chắc chắn muốn xóa mã QR trùng không?",
          "Thông báo!",
          {
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            confirmButtonText: "Có",
            cancelButtonText: "Không",
          }
      ).then(() => {
        this.buttonLoading6 = true;
        OtherService.deleteQrCodeDuplicateService(this.dataInput.date)
            .then((resp) => {
              this.$message({
                message: resp.data.message,
                type: "success",
              });
              this.checkQrCodeDuplicate();
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            })
            .finally(() => {
              setTimeout(() => {
                this.buttonLoading6 = false;
              }, 500);
            });
      });
    },


  },

};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__title {
  font-size: 25px;
  color: #606266;
}
</style>
